import React from "react";
import "./GradientBackground.css";

export default function GradientBackground() {
  return (
    <div className="gradient-background">
      <div className="gradient-layer gradient-layer-1"></div>
      <div className="gradient-layer gradient-layer-2"></div>
      <div className="gradient-layer gradient-layer-3"></div>
    </div>
  );
}
